import React from 'react';
import {observer} from 'mobx-react';
import {SearchClearIconBox} from "./boxes/search-clear-icon/search-clear-icon.box";
import {SearchInputMobileBox} from "./boxes/search-input-mobile/search-input-mobile.box";
import {SearchInputArea} from "../search-input-area/search-input-area";
import {CyClass} from "../../../../../common/cy-classes";
import {SearchIconBox} from '../search-input-pc/boxes/search-icon/search-icon.box';
import {ComponentServicesPick} from "../../../../services/component-services-pick";
import {withServices} from "../../../../react-hooks/with-services";
import {useServices} from "../../../../react-hooks/use-services.hook";

interface SearchInputMobileComponentProps extends ComponentServicesPick<'gameSearch'>{
}

const ComponentBody: React.FC<SearchInputMobileComponentProps> = observer((props) => {
    const services = useServices();
    const _onResetSearchTextHandler = () => {
        props.gameSearch.search('');
        props.gameSearch.searchInputRef?.current?.focus();
    };

    const _showResetSearchIcon = (props.gameSearch.currentSearchText || '').length > 0;

    const SearchIcon = services.theme.currentTheme.icons.searchIcon;
    return (
        <SearchInputMobileBox className={CyClass('cy-menu-item')}>
            <SearchIconBox>
                <SearchIcon size={2} />
            </SearchIconBox>
            <SearchClearIconBox className={CyClass('cy-clear-search-box-icon')} visible={_showResetSearchIcon} onClick={_onResetSearchTextHandler} />
            <SearchInputArea/>
        </SearchInputMobileBox>
    );

})

export const SearchInputMobileComponent = withServices(ComponentBody, ['gameSearch']);